import { HomePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'
import { nowBackendDateTime } from 'modules/core/lib/dates'

import Dashboard from 'modules/dashboard/components/Dashboard'

const HomePage = () => {
  const { company, employee } = useCurrentSession()

  const companyId = company.id

  const attendancePolicyId = employee?.attendanceEmployeesPolicyId

  const variables = useMemo(
    () => ({
      companyId,
      today: nowBackendDateTime(),
      employeeAttendancePolicyIds: attendancePolicyId ? [attendancePolicyId] : undefined,
    }),
    [companyId, attendancePolicyId]
  )

  const { data, loading } = useQuery(HomePageDocument, {
    variables,
  })

  const companyLinksVisible = !!data?.dashboard._policies.dashboardWidgetCompanyLinksVisible.can
  const timeTrackingVisible = !!data?.attendance._policies.dashboardWidgetTimeTrackingVisible.can

  const communitiesEnabled = !!data?.companies?.featureAvailabilitiesConnection.nodes?.some(
    (feature) => feature.id === 'communities_core' && feature.available
  )

  const timeTrackingManagementEnabled =
    !!data?.companies.featureAvailabilitiesConnection.nodes?.some(
      (feature) => feature.id === 'time_tracking_management' && feature.available
    )

  const pulseQuestionFeatureEnabled =
    data?.features?.featuresConnection?.nodes?.some(
      (feature) => feature.name === 'engagement_employee_pulse_questions' && feature.enabled
    ) || false
  const pulsSettingEnabled =
    data?.engagement?.settingsConnection?.edges[0]?.node?.employeePulseEnabled || false
  const isPulseEnabled = pulseQuestionFeatureEnabled && pulsSettingEnabled

  const pulse = data?.engagement?.employeeCurrentPulsesConnection.edges[0]?.node.pulse

  const isLoading = loading && !data

  const hasTeamStatus = data?.attendance._policies.dashboardWidgetWhoIsInVisible.can ?? false

  return (
    <Dashboard
      timeTrackingVisible={timeTrackingVisible}
      companyLinksVisible={companyLinksVisible}
      communitiesEnabled={communitiesEnabled}
      timeTrackingManagementEnabled={timeTrackingManagementEnabled}
      isLoading={isLoading}
      pulseEnabled={isPulseEnabled}
      hasTeamStatus={hasTeamStatus}
      pulse={pulse}
    />
  )
}

export default HomePage
